import { type FeedFilter } from "@/lib/feedReader";
import { getSourceRowToneVars } from "@/lib/sourceTypeRowTone";

export const FILTER_LABELS: Record<FeedFilter, string> = {
  unread: "Unread",
  starred: "Starred",
  archive: "Archive",
  all: "All",
};

export const PANE_KEY = "feed-reader:pane-sizes";
export const DEFAULT_PANES: [number, number, number] = [18, 37, 45];

// Feed items adopt the My Library "website" tone wash + accent rail.
export const FEED_TONE = getSourceRowToneVars("website");

export const formatDate = (iso: string | null) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
};

export const formatRelative = (iso: string | null) => {
  if (!iso) return "Never";
  const ms = Date.now() - new Date(iso).getTime();
  const m = Math.floor(ms / 60_000);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
};

export const readPaneSizes = (): [number, number, number] => {
  if (typeof window === "undefined") return DEFAULT_PANES;
  try {
    const raw = window.localStorage.getItem(PANE_KEY);
    if (!raw) return DEFAULT_PANES;
    const parsed = JSON.parse(raw);
    if (
      Array.isArray(parsed) &&
      parsed.length === 3 &&
      parsed.every((n) => typeof n === "number" && n > 0)
    ) {
      return parsed as [number, number, number];
    }
  } catch {
    /* ignore */
  }
  return DEFAULT_PANES;
};

export const persistPaneSizes = (sizes: number[]) => {
  if (typeof window === "undefined") return;
  if (sizes.length !== 3) return;
  window.localStorage.setItem(PANE_KEY, JSON.stringify(sizes));
};
